import * as React from 'react'
import {ReactElement} from 'react'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {NatParkingUsesInfo, NatResidentParkingUsesLocationState} from './NatResidentApplicationInterface'
import NatCurrentDateTimeRepo from '../../currentDateTime/repository/NatCurrentDateTimeRepo'
import NatCondominiumRepo from '../../condominium/repository/NatCondominiumRepo'
import {Nullable} from '../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {
    CenterPlainLinkStyledButton,
    PlainLinkStyledBackButton,
    PrimaryStyledButton,
} from '../../../../styledComponents/Button'
import {Box} from '@mui/material'
import {PageTitle} from '../common/resident/NatResidentApplicationsCommon'
import {NatPutParkingUsesRequest, NatPutParkingUsesResponse} from '../repository/NatPutParkingUses'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import NatResidentParkingUsesConfirm from './resident/NatResidentParkingUsesConfirm'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applyId?: string
    applicationRepo: NatApplicationRepo
    condominiumRepo: NatCondominiumRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    location: Location<NatResidentParkingUsesLocationState>
}

class NatResidentParkingUsesConfirmPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.handleRegisterButtonClick = this.handleRegisterButtonClick.bind(this)
        this.handleBackLinkOnClick = this.handleBackLinkOnClick.bind(this)
    }

    async handleRegisterButtonClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        const {applicationRepo, condominiumCd} = this.props
        const locationState: NatParkingUsesInfo = this.props.location.state.applyInfo
        const {
            applicantFamilyName, applicantFirstName, useArea, useStartDate,
            userFamilyName, userFirstName, userAttribute, ownerFamilyName,
            ownerFirstName, carBodyShape, carName, carRegistrationNumber,
            engineSize, length, height, width,
            vehicleWeight, vehicleTotalWeight
        } = locationState

        let request: Nullable<NatPutParkingUsesRequest>

        request = {
            applicantFamilyName: applicantFamilyName,
            applicantFirstName: applicantFirstName,
            useArea: useArea,
            useStartDate: useStartDate,
            userFamilyName: userFamilyName,
            userFirstName: userFirstName,
            userAttribute: userAttribute,
            ownerFamilyName: ownerFamilyName,
            ownerFirstName: ownerFirstName,
            carBodyShape: carBodyShape,
            carName: carName,
            carRegistrationNumber: carRegistrationNumber,
            engineSize: engineSize,
            length: length,
            height: height,
            width: width,
            vehicleWeight: vehicleWeight,
            vehicleTotalWeight: vehicleTotalWeight,
            confirmed: true
        }

        if (!request) {
            return
        }
        try {
            const response: Nullable<NatPutParkingUsesResponse> = await this.props.asyncCallFunction(
                applicationRepo.applyParkingUses.bind(
                    applicationRepo, condominiumCd, request),
                () => {
                    this.props.navigate(`/resident/error`, {replace: true})
                },
            )
            if (response && response.requestError === null) {
                this.props.navigate(
                    `/resident/condominiums/${this.props.condominiumCd}/applications/complete`,
                    {replace: true},
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleBackLinkOnClick(): void {
        const locationState: NatResidentParkingUsesLocationState = this.props.location.state
        this.props.navigate(`/resident/condominiums/${this.props.condominiumCd}/applications/parkingUses/input`, {
            replace: true,
            state: JSON.parse(JSON.stringify(locationState)),
        })
    }

    render(): ReactElement {
        return (
            <>
                <PlainLinkStyledBackButton onClick={this.handleBackLinkOnClick}>戻る</PlainLinkStyledBackButton>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    申請内容確認
                </PageTitle>
                <Box height={'20px'}/>
                <NatResidentParkingUsesConfirm
                    {...this.props.location.state.applyInfo}
                />
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton onClick={this.handleRegisterButtonClick}>
                    申請を提出する
                </PrimaryStyledButton>
                <BlockSpacer height={'20px'}/>
                <CenterPlainLinkStyledButton onClick={this.handleBackLinkOnClick}>修正する</CenterPlainLinkStyledButton>
                <BlockSpacer height={'15px'}/>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentParkingUsesConfirmPage)
